/** Internal return path from `?next=`. Rejects protocol-relative and external URLs. */
export function safeNextPath(value: string | null | undefined): string | null {
  if (!value || !value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return null;
  if (value.startsWith("/auth")) return null;
  return value;
}

export function authPathWithNext(pathname: string, search: string): string {
  const next = `${pathname}${search}`;
  if (!next.startsWith("/") || next.startsWith("/auth")) return "/auth";
  return `/auth?next=${encodeURIComponent(next)}`;
}
